import React from "react";

const Button = (props) => {
  const { className, type, disabled, children, onClick } = props;
  return (
    <button
      className={className}
      type={type || "button"}
      disabled={disabled || false}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
export default Button;
